import { Component, OnInit } from '@angular/core';
import { switchMap, take } from 'rxjs/operators';
import { fadeAnimation, listAnimation, showAnimation } from 'src/animations';
import { SidenavOption } from '../../classes';
import { SidenavService } from '../../services/sidenav.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
  animations: [ showAnimation, fadeAnimation, listAnimation ]
})
export class SidenavComponent implements OnInit {

  constructor(
    public service: SidenavService
  ) { }

  ngOnInit(): void {
  }

  oneTimeOptionClicked(option: SidenavOption){
    this.service.preventOneTimeClose$.pipe(take(1), switchMap(value => {
      if(!value) this.service.clearOneTimeOptions();
      return option.onClick();
    })).toPromise();
  }

  optionClicked(option: SidenavOption){
    this.service.preventOneTimeClose$.pipe(take(1), switchMap(value => {
      if(!value) this.service.clearOneTimeOptions();
      return option.onClick();
    })).toPromise();
  }

}
